/* unplugin-vue-components disabled */import { render } from "./Alipay.vue?vue&type=template&id=4d5dc564&scoped=true"
import script from "./Alipay.vue?vue&type=script&lang=js"
export * from "./Alipay.vue?vue&type=script&lang=js"

import "./Alipay.vue?vue&type=style&index=0&id=4d5dc564&scoped=true&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5dc564"]])

export default __exports__